import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Catalogo } from './catalogo';
import { Canales } from './canales';
import { CrudService } from './crud-service.service';

@Injectable({
  providedIn: 'root'
})
export class CanalesService   extends CrudService<Canales> {

 
   constructor(http: HttpClient) {
    super(http, environment.apiUrl ); 
  }
   eliminar(id: number) {
    return this.http.delete<void>(
      `${this.baseUrl}/eliminarCanales/?id=${id}`
    );
  }
  

  listarPorEmisor(idEmisor) {
    return this.http.get<Canales[]>(
      `${this.baseUrl}/listarCanales/?idEmisor=${idEmisor}`
    );
  }

    listarPorEmisorTipo(idEmisor) {
    return this.http.get<Canales[]>(
      `${this.baseUrl}/listarCanalesPorIdTipo/?idEmisor=${idEmisor}`
    );
  }

    setActulizar(canales: any[]) {
  return this.http.put(
     `${this.baseUrl}/actulizarCanales`,
    canales,
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
}
}
